import { regulationId } from '@/utils/regulationLabels'

// Every assigned regulation, the search regulation first (it is the one the
// preview falls back to, see the "Ensure previewRegulation" effect).
export function defaultTargetRegulations(regulations = [], sourceRegulation = '') {
  const ids = regulations.map(regulationId).filter(Boolean)
  if (!sourceRegulation || !ids.includes(sourceRegulation)) return ids
  return [sourceRegulation, ...ids.filter((id) => id !== sourceRegulation)]
}
